<template>
  <vue-draggable-resizable
    :w="width"
    :h="height"
    :x="posX"
    :y="posY"
    :active="true"
    :parent="true"
    :resizable="true"
    @resizing="onResizing"
    @dragstop="onDragStop"
    class-name-handle="object-form-resizable-handle"
    :drag-handle="'.drag'"
    data-app
  >
    <div
      class="changeLogForm"
      ref="changeLogForm"
      :style="{ height: height + 'px' }"
    >
      <form-header :title="pageTitle" @close="close" />

      <change-log-data-table
        style=" overflow: auto; height: calc(100% - 74px); margin: 20px"
        class="overflow-y-auto"
      />
    </div>
  </vue-draggable-resizable>
</template>

<script>
import { bus } from "@/main";
import FormHeader from "@/components/Home/Forms/_Molecules/FormHeader";
import ChangeLogDataTable from "@/components/Home/Forms/ChangeLogForm/ChangeLogDataTable";

export default {
  name: "ChangeLogForm",
  components: { ChangeLogDataTable, FormHeader },

  props: {
    previousPosX: {
      type: Number
    },

    previousPosY: {
      type: Number
    }
  },

  data() {
    return {
      posY: 100,
      posX: 400,
      width: 800,
      height: 450
    };
  },

  mounted() {
    let element = this.$refs.changeLogForm;
    this.$nextTick(() => {
      // Sets the initial position of the form (centers it)
      this.setInitialPosition(element);
    });
  },

  computed: {
    pageTitle() {
      let objectIdentifier =
        this.$store.getters.selectedObjectIdentifiers.label ?
        this.$store.getters.selectedObjectIdentifiers.label :
        this.$store.getters.selectedObjectIdentifiers.id;
      return this.$i18n.t('ChangeLog') + ' - ' + objectIdentifier;
    }
  },

  methods: {
    onResizing(left, top, width, height) {
      this.height = height;
      this.width = width;
    },
    onDragStop(x, y) {
      bus.$emit("update-object-form-position", { x: x, y: y });
      this.posX = x;
      this.posY = y;
    },
    /**
     * Defines the initial position of the current component.
     */
    setInitialPosition(element) {
      if (this.previousPosX) {
        if (element.offsetWidth - this.width > this.previousPosX) {
          this.posX = this.previousPosX;
        } else {
          this.posX = 20;
        }
      } else {
        this.posX = Math.round((element.offsetWidth - this.width) / 2);
      }

      if (this.previousPosY) {
        if (element.offsetHeight - this.height > this.previousPosY) {
          this.posY = this.previousPosY;
        } else {
          this.posY = 20;
        }
      } else {
        this.posY = Math.round((element.offsetHeight - this.height) / 2);
      }
      bus.$emit("update-object-form-position", { x: this.posX, y: this.posY });
    },

    /**
     * Closes de Change Log Form
     */
    close() {
      this.$emit("close", this);
    }
  }
};
</script>

<style scoped>
.changeLogForm {
  background-color: #f0f0ef;
  font-size: 10px;
  border-radius: 5px;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/ChangeLogForm/ChangeLogForm.vue